// Vendor imports
const cookie = require('js-cookie')

/**
 * UNIX timestamp is represented as a signed 32-bit integer (in seconds);
 * any dates beyond that are not safe for HTTP Cookies, and may result in
 * the cookie being instantly deleted due to integer overflow.
 * @see https://stackoverflow.com/a/34586818
 * @warning This code will need to be changed before 2038!
 * @see https://en.wikipedia.org/wiki/Year_2038_problem
 */
const END_OF_32BIT_UNIX_TIMESTAMP = Math.pow(2, 31) - 1
const END_OF_32BIT_UNIX_TIMESTAMP_DATE = new Date(END_OF_32BIT_UNIX_TIMESTAMP * 1000)

// Action types

const DISMISS = 'LIGHTWEIGHT_ENGAGEMENT_TUTORIAL_DISMISS'

// Action dispatchers

function dismiss() {
  return function (dispatch) {
    setDismissedCookie()
    dispatch({ type: DISMISS })
  }
}

// Helpers

function setDismissedCookie() {
  /**
   * This is stored as a cookie so that the server can also read it.
   * Ideally, this flag would be stored server-side, but this is the
   * quickest solution for right now.
   */
  cookie.set('tutorial_lwe_dismissed', '1', {
    expires: END_OF_32BIT_UNIX_TIMESTAMP_DATE
  })
}

// Exports

module.exports = {
  // Action types
  DISMISS,
  // Action dispatchers
  dismiss
}
